export default __webpack_public_path__ + "assets/omnivore-poster.b923837c.png";